import { Fields } from './types';

export const useDefaultValues = () => {
  const initialValue: Fields = {
    password: '',
    passwordConfirmation: '',
  };
  return initialValue;
};
